@import 'vars';
@import 'mixins';

$avatar-min-width: 40px;
$sign-out-mid-width: 100px;
$user-info-max-width: 300px;
$context-max-width-desktop: 700px;
$context-max-width-tablet: 780px;
$context-right-margin-desktop: 100px;

.auth-screen {
  background: white;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__user {
    position: sticky;
    top: 0px;
    background: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: $padding-xlarge;

    @include softphone-and-under {
      padding: unset;
      padding-top: $padding-medium;
      margin-left: $padding-medium;
      margin-right: $padding-medium;
      padding-bottom: $padding-medium;
      justify-content: flex-start;
      border-bottom: 1px solid $mid-grey;
    }

    @include small-softphone-and-under {
      padding: unset;
      padding-top: $padding-small;
      margin-left: $padding-small;
      margin-right: $padding-small;
      padding-bottom: $padding-small;
      justify-content: flex-start;
      border-bottom: 1px solid $mid-grey;
    }

    @include tablet-and-over {
      justify-content: flex-end;
    }

    &__sign-out {
      min-width: $sign-out-mid-width !important;

      @include softphone-and-under {
        margin-left: auto !important;
      }
    }

    &__info {
      display: inline-block;
      margin-left: $padding-small;
      margin-right: $margin-large;
      max-width: $user-info-max-width;
      min-width: 0;

      @include softphone-and-under {
        margin-right: $margin-small;
      }

      > * {
        margin: 0;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        overflow: hidden;
      }
    }

    &__heading {
      @include softphone-and-under {
        font-size: $font-size-small;
      }
    }

    &__subheading {
      @include softphone-and-under {
        font-size: $font-size-small;
      }
    }
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: $padding-large $padding-large 0px $padding-large;

    @include softphone-and-under {
      padding: $padding-medium $padding-medium 0px $padding-medium;
    }

    @include small-softphone-and-under {
      padding: $padding-small $padding-small 0px $padding-small;
    }

    &__main {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: $gap-xlarge;
      max-width: $context-max-width-desktop;

      @include tablet-and-under {
        max-width: $context-max-width-tablet;
      }

      @include softphone-and-under {
        margin-top: $padding-medium;
        gap: $gap-large;
      }

      @include tablet-and-over {
        margin-right: $margin-medium;
      }

      @include desktop-and-over {
        margin-right: $context-right-margin-desktop;
      }
    }

    &__heading {
      @include softphone-and-under {
        font-size: $font-size-extra-large-softphone;
      }
    }

    &__subheading {
      @include softphone-and-under {
        font-size: $font-size-small-softphone;
        margin-top: unset;
      }

      margin-top: $padding-small;
      display: block;
    }

    &__left {
      display: flex;
      gap: $gap-large;
      flex-direction: column;
    }

    &__section {
      display: flex;
      align-items: center;
      gap: $padding-medium;

      @include softphone-and-over {
        padding: $padding-medium;
        border-radius: $padding-medium;
        border: 1px solid $mid-grey;
      }

      &__heading {
        @include softphone-and-under {
          font-size: $font-size-large-softphone;
        }
      }
    }
  }

  &__image {
    display: flex;

    @include softphone-and-under {
      display: none;
    }
  }

  &__buttons {
    display: flex;
    gap: $gap-large;

    @include small-softphone-and-under {
      flex-direction: column;
    }
  }

  &__support-footer {
    padding: 25px;

    @include softphone-and-under {
      padding: $padding-medium;
    }
    @include small-softphone-and-under {
      padding: $padding-small;
    }
  }
}
